const REQUEST_TYPE = "LEADMAGNET_EMAIL_SCAN_REQUEST";
const RESULT_TYPE = "LEADMAGNET_EMAIL_SCAN_RESULT";
const BRIDGE_SOURCE = "markengroup-leadmagnet-email-scanner";

export function isGoogleChromeBrowser(browserNavigator = globalThis.navigator) {
  if (!browserNavigator) return false;
  const brands = browserNavigator.userAgentData?.brands || [];
  if (brands.length) return brands.some(({ brand }) => brand === "Google Chrome");
  const userAgent = browserNavigator.userAgent || "";
  return browserNavigator.vendor === "Google Inc."
    && /Chrome\/\d+/i.test(userAgent)
    && !/(?:Edg|OPR|CriOS)\//i.test(userAgent);
}

export function installedEmailScannerVersion(pageDocument = globalThis.document) {
  const value = pageDocument?.documentElement?.dataset?.leadmagnetEmailScanner || "";
  return value === "ready" ? "legacy" : value;
}

export function compareVersions(left = "", right = "") {
  const leftParts = left.split(".").map((part) => Number.parseInt(part, 10) || 0);
  const rightParts = right.split(".").map((part) => Number.parseInt(part, 10) || 0);
  for (let index = 0; index < Math.max(leftParts.length, rightParts.length); index += 1) {
    const difference = (leftParts[index] || 0) - (rightParts[index] || 0);
    if (difference) return Math.sign(difference);
  }
  return 0;
}

export function emailScannerStatus(requiredVersion, browserNavigator = globalThis.navigator, pageDocument = globalThis.document) {
  const isChrome = isGoogleChromeBrowser(browserNavigator);
  const installedVersion = isChrome ? installedEmailScannerVersion(pageDocument) : "";
  const isInstalled = Boolean(installedVersion);
  const isCurrent = isInstalled && installedVersion !== "legacy" && compareVersions(installedVersion, requiredVersion) >= 0;
  return { isChrome, isInstalled, isCurrent, installedVersion };
}

export function emailScannerInstalled() {
  return Boolean(installedEmailScannerVersion());
}

export function scanWebsiteForEmails(websiteUrl) {
  if (!emailScannerInstalled()) {
    throw new Error("Die LeadMagnet E-Mail-Scanner-Erweiterung wurde nicht erkannt. Bitte die Erweiterung installieren und diese Seite neu laden.");
  }

  const requestId = globalThis.crypto?.randomUUID?.() || `${Date.now()}-${Math.random()}`;
  return new Promise((resolve, reject) => {
    const timeout = window.setTimeout(() => {
      window.removeEventListener("message", handleResult);
      reject(new Error("Der E-Mail-Scanner hat nicht rechtzeitig geantwortet."));
    }, 95000);

    function handleResult(event) {
      const message = event.data;
      if (event.source !== window
        || event.origin !== window.location.origin
        || message?.source !== BRIDGE_SOURCE
        || message?.type !== RESULT_TYPE
        || message?.requestId !== requestId) return;

      window.clearTimeout(timeout);
      window.removeEventListener("message", handleResult);
      if (message.error) reject(new Error(message.error));
      else resolve(message.result || { emails: [], people: [], scannedUrls: [] });
    }

    window.addEventListener("message", handleResult);
    window.postMessage({
      source: BRIDGE_SOURCE,
      type: REQUEST_TYPE,
      requestId,
      websiteUrl
    }, window.location.origin);
  });
}
